import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface STSRequest {
  file_name?: string;
  login_token?: string;
}

export interface STSState {
  account_id?: string;
  region?: string;
  endpoint?: string;
  bucket?: string;
  ak?: string;
  sk?: string;
  token?: string;
  current_time?: number;
  expired_time?: number;
  key?: string;
}

/**
 * 当前 sts相关信息
 */
export const stsSlice = createSlice({
  name: 'sts',
  initialState: {} as STSRequest,
  reducers: {
    setSTSParams: (state, action: PayloadAction<STSRequest>) => {
      state.login_token = action.payload.login_token;
    },
    removeSTSParams: (state) => {
        state.login_token = undefined;
    },
  },
});

export const { setSTSParams, removeSTSParams } = stsSlice.actions;

export default stsSlice.reducer;
